import type { SVGProps } from 'react';

const SvgFavoriteSavedSearches = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m20.71 19.29-3.39-3.39C18.41 14.5 19 12.8 19 11c0-4.41-3.59-8-8-8-3.73 0-7.02 2.64-7.82 6.29-.12.54.22 1.07.76 1.19a.996.996 0 0 0 1.19-.76c.6-2.73 3.06-4.71 5.86-4.71 3.31 0 6 2.69 6 6 0 1.6-.62 3.11-1.76 4.24a.996.996 0 0 0 0 1.41l4.05 4.05c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41z"
    />
    <path
      fill="currentcolor"
      d="M11.91 12.85c-.9-.63-2.08-.78-3.15-.39q-.6.21-1.05.6-.465-.39-1.05-.6c-1.08-.38-2.26-.24-3.15.39-.85.6-1.39 1.52-1.48 2.54s.28 2.02 1 2.75l3.27 3.27a1.983 1.983 0 0 0 2.82 0l3.27-3.27c.72-.72 1.09-1.73 1-2.75a3.46 3.46 0 0 0-1.48-2.54m-3.73-1.88c.41 0 .79-.25.94-.66.29-.79 1.04-1.32 1.88-1.32.55 0 1-.45 1-1s-.45-1-1-1a4.01 4.01 0 0 0-3.76 2.63.998.998 0 0 0 .94 1.34z"
    />
  </svg>
);
export default SvgFavoriteSavedSearches;
